export const mapState = ({ authReducer }, { intl }) => {
  return {
    intl,
    authReducer
  }
}
